import React from 'react'

import useDidMount from '@divvy-web/hooks.usedidmount'
import { FormattedMessage } from '@divvy-web/i18n'
import { BannerType } from '@divvy-web/skylab.banner'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import { useTrackCollaboratorEvent } from '@sputnik/hooks/useApplicationCollaborators'
import useGoToOffers from '@sputnik/hooks/useGoToOffers'
import StatusBanner from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/ApplicationDetailsTabContent/ActionsNeededSection/StatusBanner'

interface OfferReadyBannerProps {
  salesforceCreditId: string
  authorizedSignerEmail: string
}

const OfferReadyBanner = ({ salesforceCreditId, authorizedSignerEmail }: OfferReadyBannerProps) => {
  const { handleGoToOffers, isLoadingGoToOffers, isLoggedInUserAuthorizedSigner } = useGoToOffers({
    salesforceCreditId,
    authSignerEmail: authorizedSignerEmail,
  })

  const { trackCollaboratorEvent } = useTrackCollaboratorEvent({
    salesforceCreditId,
  })

  useDidMount(() => {
    trackCollaboratorEvent('se_signup__application_dashboard_action_needed_offer_ready__presented', (role) => ({
      is_auth_signer: role === 'authorizedSigner',
    }))
  })

  return (
    <div className='fs-unmask'>
      <StatusBanner
        bannerType={BannerType.Informative}
        subtext={
          <FormattedMessage
            defaultMessage='Take advantage of your credit line. {offerLink}'
            id='sputnik.OfferReadyBanner__dezVS5'
            values={{
              offerLink: (
                <TextLink
                  disabled={isLoadingGoToOffers}
                  size={TextLinkSizes.SMALL}
                  onClick={() => {
                    trackCollaboratorEvent('se_signup__application_dashboard_action_needed_review_offer__fired')
                    handleGoToOffers()
                  }}
                >
                  <FormattedMessage
                    defaultMessage='{isLoggedInUserAuthorizedSigner, select, 
                        true {Review and accept offer}
                        other {Review offer}
                      }'
                    id='sputnik.OfferReadyBanner__81D6F6'
                    values={{ isLoggedInUserAuthorizedSigner }}
                  />
                </TextLink>
              ),
            }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Your offer is ready!'
            id='sputnik.OfferReadyBanner__1JRfgv'
          />
        }
      />
    </div>
  )
}

export default OfferReadyBanner
